const sortConfig = [
  {
    type: "car",
    config: [
      {
        label: "year",
        value: "year",
        order: "ASC",
        orderBy: "meta_value",
        metaKey: "construction_year",
        isDefault: true,
      },
      {
        label: "title",
        value: "title",
        order: "ASC",
        orderBy: "title",
        metaKey: false,
        isDefault: true,
      },
    ]
  },
  {
    type: "art",
    config: [
      {
        label: "year",
        value: "year",
        order: "ASC",
        orderBy: "meta_value",
        metaKey: "construction_year",
        isDefault: true,
      },
      {
        label: "artist",
        value: "artist",
        order: "ASC",
        orderBy: "meta_value",
        metaKey: "artist",
        isDefault: true,
      }
    ]
  }
];

export default sortConfig;
